/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * answer of offerData call
 */
export interface OfferDataResponse { 
    /**
     * offer id / fca
     */
    contractId?: string;
    moveAbility?: string;
}

